import HTTP from '../HTTP';

const OPPORTUNITE_URL = 'opportunites/';

export async function sendOpportunite(opportunite) {
  try {
    const response = await HTTP.post(OPPORTUNITE_URL, opportunite);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getMesOpportunitesPaginated(userId, data) {
  try {
    const query = {
      take: data.limit,
      skip: (data.page - 1) * data.limit,
      sortBy: 'datecreation',
      sortDirection: 'desc',
      query: data.query,
    };
    if (data.orderBy) {
      query.sortBy = data.orderBy.toLowerCase();
      query.sortDirection = data.ascending === 1 ? 'asc' : 'desc';
    }
    const response = await HTTP.get(OPPORTUNITE_URL + 'by/user/' + userId, { params: query });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function browseDetailOpportunite(id) {
  try {
    const response = await HTTP.get(OPPORTUNITE_URL + id);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function supprime(id) {
  try {
    const response = await HTTP.delete(OPPORTUNITE_URL + id);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function other() {
  try {
    const response = await HTTP.get(OPPORTUNITE_URL);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getOppByProduct(product, productId, limit) {
  try {
    const query = {
      product,
      productId,
      propriety: 'userId, annonceurGuid, themeCampagne, dateCreation',
      limit,
    };
    const response = await HTTP.get(`${OPPORTUNITE_URL}by/product`, { params: query });
    return response;
  } catch (e) {
    throw e;
  }
}


export async function putOpportunite(id, opportunite) {
  try {
    const response = await HTTP.put(OPPORTUNITE_URL + id, opportunite);
    return response;
  } catch (e) {
    throw e;
  }
}
export async function getPrevisualiserPdf(opportunite) {
  try {
    const response = await HTTP.post(`${OPPORTUNITE_URL}pdf/previsu`, opportunite, { responseType: 'blob' });
    return response;
  } catch (e) {
    throw e;
  }
}



// WEBPACK FOOTER //
// ./src/api/opportunite/index.js